import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ErrorComponent from '../../../shared-components/ErrorComponent/ErrorComponent';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './ErrorPage.less';

export class ErrorPage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        return (
            <div className="us-wrapper">
                <div className="ErrorPage">
                    <ErrorComponent
                        Header={Header}
                        Footer={Footer}
                    />
                </div>
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_errorpage', 'prepare_pp_credit_errorpage'));
    }
});

export default connect(null, mapDispatchToProps)(ErrorPage);
